module.exports = __webpack_public_path__ + "static/img/kldn_bg_1280.ff3401b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kldn_bg_1280.png
// module id = tX3W
// module chunks = 1